"use client";

import { c as _c } from "react/compiler-runtime";
import { Identifier } from "@/types/domain";
import React, { useMemo, useState } from "react";
import { useTranslations } from "next-intl";
import { WidgetsContainer } from "@components/common/containers/widgets-container";
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "@components/ui/select";
import { useAppSelector } from "@lib/redux/hooks";
import { selectWorkspacesEvents } from "@features/events/events-selectors";
import { EventStage } from "@features/events/types/event";
import { EventCard } from "@features/events/ui/event-card";
import { useGetWorkspacesEventsQuery } from "@features/workspaces/hooks/use-get-workspaces-events-query";
import { selectUserWorkspaces } from "@features/workspaces/workspaces-selectors";
import { eventsTools } from "@features/events/events-tools";
import { AssignmentNotificationsPanel, useAssignmentNotificationsController } from "@features/notifications/components/assignment-notifications-panel";
interface DashboardControllerProps {
  isPrivate?: boolean;
}
export const DashboardController = t0 => {
  const $ = _c(37);
  const {
    isPrivate
  } = t0;
  const t = useTranslations("features.application.ui.dashboard.workspaceFilter");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["PLANNING", "PREPARING", "PROGRESSING", "ANALYSING"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      stages: t1 as EventStage[],
      withModules: true
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const queryParams = t2;
  useGetWorkspacesEventsQuery(queryParams);
  const assignmentNotificationsController = useAssignmentNotificationsController();
  const showAssignmentNotificationsPanel = !assignmentNotificationsController.isError && !assignmentNotificationsController.isInitialLoading && assignmentNotificationsController.model.items.length > 0;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = selectWorkspacesEvents(queryParams);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const events = useAppSelector(t3);
  const workspaces = useAppSelector(selectUserWorkspaces);
  const [selectedWorkspaceId, setSelectedWorkspaceId] = useState(null);
  let t4;
  bb0: {
    if (!events) {
      let t5;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = new Map();
        $[3] = t5;
      } else {
        t5 = $[3];
      }
      t4 = t5;
      break bb0;
    }
    let countMap;
    if ($[4] !== events) {
      countMap = new Map();
      events.forEach(event => {
        if (event.workspaceId) {
          const currentCount = countMap.get(event.workspaceId) || 0;
          countMap.set(event.workspaceId, currentCount + 1);
        }
      });
      $[4] = events;
      $[5] = countMap;
    } else {
      countMap = $[5];
    }
    t4 = countMap;
  }
  const workspaceEventCountMap = t4;
  let t5;
  if ($[6] !== workspaceEventCountMap) {
    const workspaceEntries = Array.from(workspaceEventCountMap.entries());
    t5 = workspaceEntries.sort(_temp);
    $[6] = workspaceEventCountMap;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const sortedWorkspacesWithCounts = t5;
  let t6;
  bb1: {
    if (!selectedWorkspaceId || !events) {
      let t7;
      if ($[8] !== events) {
        t7 = events?.sort(eventsTools.sortEventsByDate);
        $[8] = events;
        $[9] = t7;
      } else {
        t7 = $[9];
      }
      t6 = t7;
      break bb1;
    }
    let t7;
    if ($[10] !== events || $[11] !== selectedWorkspaceId) {
      let t8;
      if ($[13] !== selectedWorkspaceId) {
        t8 = event_0 => event_0.workspaceId === selectedWorkspaceId;
        $[13] = selectedWorkspaceId;
        $[14] = t8;
      } else {
        t8 = $[14];
      }
      t7 = events.filter(t8).sort(eventsTools.sortEventsByDate);
      $[10] = events;
      $[11] = selectedWorkspaceId;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    t6 = t7;
  }
  const filteredEvents = t6;
  const showWorkspaceFilter = sortedWorkspacesWithCounts.length > 1;
  let t7;
  if ($[15] !== assignmentNotificationsController || $[16] !== showAssignmentNotificationsPanel) {
    t7 = showAssignmentNotificationsPanel && <div className="@container/dashboard-top" data-testid="dashboard-top-row-container"><WidgetsContainer data-testid="dashboard-top-row" layoutClassName="grid auto-rows-min grid-cols-1 gap-4 @[1025px]/dashboard-top:grid-cols-[minmax(28rem,48rem)_minmax(0,1fr)] @[1440px]/dashboard-top:grid-cols-[minmax(30rem,48rem)_repeat(2,minmax(0,1fr))] @[2000px]/dashboard-top:grid-cols-[minmax(32rem,48rem)_repeat(3,minmax(0,1fr))] @[2400px]/dashboard-top:grid-cols-[minmax(32rem,48rem)_repeat(4,minmax(0,1fr))]" withoutWidgetPlace={true}><div className="w-full max-w-[48rem] overflow-hidden rounded-lg border bg-card" data-testid="dashboard-assignment-notifications"><AssignmentNotificationsPanel {...assignmentNotificationsController} mode="embedded" listClassName="h-[clamp(18rem,32vh,28rem)]" /></div></WidgetsContainer></div>;
    $[15] = assignmentNotificationsController;
    $[16] = showAssignmentNotificationsPanel;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== selectedWorkspaceId || $[19] !== showWorkspaceFilter || $[20] !== sortedWorkspacesWithCounts || $[21] !== t || $[22] !== workspaces) {
    t8 = showWorkspaceFilter && <div className="flex items-center gap-2"><span className="text-sm font-medium">{t("label")}:</span><Select value={selectedWorkspaceId as string ?? "all"} onValueChange={value => setSelectedWorkspaceId(value === "all" ? null : value)}><SelectTrigger className="w-[250px]"><SelectValue placeholder={t("placeholder")} /></SelectTrigger><SelectContent><SelectGroup><SelectItem value="all">{t("allWorkspaces")}</SelectItem>{sortedWorkspacesWithCounts.map(t9 => {
              const [workspaceId, count] = t9;
              const workspaceName = workspaces?.find(w => w.id === workspaceId)?.hint || workspaceId;
              return <SelectItem key={workspaceId} value={workspaceId as string}>{workspaceName} ({count})</SelectItem>;
            })}</SelectGroup></SelectContent></Select></div>;
    $[18] = selectedWorkspaceId;
    $[19] = showWorkspaceFilter;
    $[20] = sortedWorkspacesWithCounts;
    $[21] = t;
    $[22] = workspaces;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== filteredEvents || $[25] !== isPrivate || $[26] !== selectedWorkspaceId || $[27] !== workspaces) {
    t9 = filteredEvents?.map(event_1 => <EventCard key={event_1.id} event={event_1} mode="dashboard" showDashboardLink={true} showWorkspaceInfo={!selectedWorkspaceId} workspace={event_1.workspaceId ? workspaces?.find(w_0 => w_0.id === event_1.workspaceId) : undefined} isPrivate={isPrivate} hideSeasonAndVenue={true} />);
    $[24] = filteredEvents;
    $[25] = isPrivate;
    $[26] = selectedWorkspaceId;
    $[27] = workspaces;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t9) {
    t10 = <WidgetsContainer className="min-[2200px]:grid-cols-5 2xl:grid-cols-4" withoutWidgetPlace={true}>{t9}</WidgetsContainer>;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t10 || $[32] !== t8) {
    t11 = <section className="flex flex-col gap-4" data-testid="dashboard-events-section">{t8}{t10}</section>;
    $[31] = t10;
    $[32] = t8;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t11 || $[35] !== t7) {
    t12 = <div className="flex h-full flex-col gap-6" data-testid="dashboard-content">{t7}{t11}</div>;
    $[34] = t11;
    $[35] = t7;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  return t12;
};
function _temp(a, b) {
  return b[1] - a[1];
}